import type { ISubscriptionUserRepository } from '../ISubscriptionUserRepository';
import type {
  TotalSubscriptionUserCountDTO,
  TotalSubscriptionUserCountFilter,
  TotalSubscriptionUserListDTO,
  TotalSubscriptionUserListFilter,
  UserLicenseListFilter,
  UserSubscriptionDTO,
} from '../subscriptionUser.types';
import { injectable } from 'inversify';
import qs from 'qs';
import API from '@repositories/Axios';
import type { Page } from '@type/Page';

@injectable()
export class SubscriptionUserRepository implements ISubscriptionUserRepository {
  async getUserLicenseList(queries: UserLicenseListFilter): Promise<Page<UserSubscriptionDTO>> {
    const queryString = qs.stringify(queries);
    const resultFromServer = await API.get<Page<UserSubscriptionDTO>>(`/api/v1/user-subscriptions?${queryString}`);
    return resultFromServer.data;
  }
  async getTotalSubscriptionUserList(
    queries: TotalSubscriptionUserListFilter,
  ): Promise<Page<TotalSubscriptionUserListDTO>> {
    const queryString = qs.stringify(queries);
    const result = await API.get<Page<TotalSubscriptionUserListDTO>>(`/api/v1/total-subscription-users?${queryString}`);
    return result.data;
  }
  async getTotalSubscriptionUserCount(
    queries: TotalSubscriptionUserCountFilter,
  ): Promise<TotalSubscriptionUserCountDTO> {
    const queryString = qs.stringify(queries);
    const result = await API.get<TotalSubscriptionUserCountDTO>(`/api/v1/total-subscription-user-count?${queryString}`);
    return result.data;
  }
}
